export const animeNews = [
  {
    id: "news-1",
    title: "《葬送的芙莉莲》第二季正式定档，2026 年 1 月温暖回归",
    category: "TV动画",
    publishedAt: "2026-10-12",
    dateLabel: "2026-10-12",
    summary:
      "官方公开第二季首支预告与主视觉，芙莉莲与费伦的旅程将继续向北，动画制作仍由 Madhouse 担任。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20inspired%20illustration%20of%20a%20young%20mage%20girl%20walking%20through%20a%20vast%20snowy%20fantasy%20landscape%20with%20soft%20blue%20mist%20and%20golden%20light%2C%20painterly%20texture%2C%20cinematic%20wide%20composition%2C%20no%20text&width=800&height=500&seq=news-cover-01&orientation=landscape",
    content: [
      "万众期待的《葬送的芙莉莲》第二季终于官宣定档，将于 2026 年 1 月正式开播。官方在最新发布会上公开了首支预告片与主视觉图，精灵魔法使芙莉莲与新伙伴费伦的旅程将继续向北方展开。",
      "### 延续「时间」与「告别」的核心命题",
      "第一季以「漫长生命中的告别」为情感内核，获得了观众与评论界的一致好评。制作组表示，第二季将进一步展开芙莉莲对人类情感的理解，同时引入更多一级魔法使的设定与战斗场面。",
      "### 制作阵容与视觉升级",
      "本季依旧由 Madhouse 负责动画制作，导演与系列构成保持原班人马。从预告片来看，背景美术与魔法特效的层次感明显提升，雪原、遗迹与魔法工房的场景细节令人印象深刻。",
      "官方同步公开了主题曲演唱者与新的角色设定图，更多播出与配信信息将在后续公布。对于追更的观众来说，这无疑是 2026 年冬季最值得期待的作品之一。",
    ],
    tags: ["葬送的芙莉莲", "定档", "奇幻", "Madhouse"],
    views: 12840,
  },
  {
    id: "news-2",
    title: "剧场版《鬼灭之刃 无限城篇》票房突破 300 亿日元",
    category: "剧场版",
    publishedAt: "2026-10-11",
    dateLabel: "2026-10-11",
    summary:
      "上映六周后，无限城篇累计票房正式突破 300 亿日元，成为本年度最具话题度的动画电影之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20stylized%20illustration%20of%20a%20swordsman%20facing%20a%20glowing%20traditional%20japanese%20castle%20at%20night%20with%20purple%20and%20orange%20energy%20effects%2C%20dynamic%20action%20composition%2C%20painterly%20anime%20style%2C%20no%20text&width=800&height=500&seq=news-cover-02&orientation=landscape",
    content: [
      "剧场版《鬼灭之刃 无限城篇》上映六周后，官方宣布其日本国内累计票房正式突破 300 亿日元，观影人次持续攀升，成为本年度最具话题度的动画电影之一。",
      "### 高规格作画引爆口碑",
      "影片以无限城为舞台，集中呈现了多场高强度对决。ufotable 一贯的高规格作画与光影演出，让不少观众直呼「在大银幕上看才过瘾」。",
      "### 全球同步发行策略",
      "除日本本土外，影片在多个海外市场同步上映，并推出了多语言字幕版本，进一步扩大了作品的国际影响力。",
      "随着票房走高，官方也宣布将追加纪念周边与线下联动活动，为影迷提供更多参与方式。",
    ],
    tags: ["鬼灭之刃", "剧场版", "票房", "ufotable"],
    views: 20310,
  },
  {
    id: "news-3",
    title: "《咒术回战》漫画进入最终章，官方发布完结预告",
    category: "漫画新闻",
    publishedAt: "2026-10-10",
    dateLabel: "2026-10-10",
    summary:
      "连载多年的《咒术回战》宣布进入最终章，作者向读者致谢，并预告故事将迎来完整收束。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20stylized%20illustration%20of%20a%20lone%20figure%20standing%20in%20a%20rainy%20neon%20lit%20city%20street%20with%20deep%20red%20and%20teal%20tones%2C%20dramatic%20ink%20brush%20anime%20style%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=news-cover-03&orientation=landscape",
    content: [
      "在最新一期杂志中，《咒术回战》官方宣布作品正式进入最终章。连载多年的故事即将走向尾声，作者也在卷末留言中向一路支持的读者表达感谢。",
      "### 剧情走向引发讨论",
      "随着最终章开启，多条此前铺垫的线索开始收束，读者的讨论热度居高不下。社区中关于角色命运与能力设定的分析帖数量明显增多。",
      "### 单行本与动画联动",
      "出版社表示，最终章的单行本将追加特别附录内容，同时与动画版进行联动宣传，为整个系列画上完整的句点。",
    ],
    tags: ["咒术回战", "漫画", "最终章"],
    views: 15620,
  },
  {
    id: "news-4",
    title: "《间谍过家家》第三季公开全新主视觉与角色设定",
    category: "TV动画",
    publishedAt: "2026-10-09",
    dateLabel: "2026-10-09",
    summary:
      "阿尼亚一家再度集结，第三季主视觉以家庭日常与任务线交错为主题，播出时间同步公布。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cheerful%20stylized%20illustration%20of%20a%20cozy%20family%20living%20room%20with%20pastel%20pink%20and%20mint%20tones%20and%20soft%20morning%20light%2C%20playful%20anime%20style%2C%20inviting%20composition%2C%20no%20text&width=800&height=500&seq=news-cover-04&orientation=landscape",
    content: [
      "《间谍过家家》官方公开了第三季的全新主视觉图与角色设定。画面中，福杰一家再度集结，日常的温馨与任务线的紧张形成有趣反差。",
      "### 喜剧与谍战的双线并进",
      "第三季将继续平衡家庭喜剧与谍战悬疑两条主线，在保证轻松氛围的同时，逐步推进更宏大的剧情背景。",
      "### 播出与配信信息",
      "官方同步公布了播出时间与国内外配信平台，粉丝可以第一时间追更。更多宣传影像将在临近播出时陆续释出。",
    ],
    tags: ["间谍过家家", "第三季", "主视觉"],
    views: 9870,
  },
  {
    id: "news-5",
    title: "《我推的孩子》动画与真人企划联动，推出特别篇情报",
    category: "TV动画",
    publishedAt: "2026-10-08",
    dateLabel: "2026-10-08",
    summary:
      "动画与真人改编企划宣布联动，公开特别篇播出计划与演员阵容花絮，引发粉丝热议。",
    cover:
      "https://readdy.ai/api/search-image?query=Glamorous%20stylized%20illustration%20of%20a%20concert%20stage%20with%20glowing%20spotlights%20and%20neon%20pink%20and%20violet%20stage%20lights%2C%20energetic%20idol%20anime%20aesthetic%2C%20no%20text&width=800&height=500&seq=news-cover-05&orientation=landscape",
    content: [
      "《我推的孩子》动画与真人改编企划宣布展开联动，官方公开了特别篇的播出计划与幕后花絮，迅速登上各大社交平台的话题榜。",
      "### 从画面到舞台的跨越",
      "作品以偶像与演艺圈为背景，对舞台演出的刻画尤为细腻。此次联动让观众得以从不同媒介重新理解同一个故事。",
      "### 特别篇看点",
      "特别篇将补完部分剧情空档，并加入原创演出段落。制作组表示，希望在保持原作气质的前提下，带来新鲜的表现手法。",
    ],
    tags: ["我推的孩子", "联动", "特别篇"],
    views: 11250,
  },
  {
    id: "news-6",
    title: "《链锯人》剧场版《蕾塞篇》公布首支正式预告",
    category: "剧场版",
    publishedAt: "2026-10-07",
    dateLabel: "2026-10-07",
    summary:
      "预告以雨夜城市与激烈战斗为核心，展现了极具冲击力的分镜与配乐，定档信息一并公开。",
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20stylized%20illustration%20of%20a%20rain%20soaked%20chaotic%20japanese%20city%20alley%20at%20night%20with%20harsh%20red%20and%20blue%20lighting%20and%20dynamic%20motion%2C%20inked%20anime%20style%2C%20no%20text&width=800&height=500&seq=news-cover-06&orientation=landscape",
    content: [
      "《链锯人》剧场版《蕾塞篇》公开首支正式预告。短短两分钟的画面里，雨夜城市、爆炸特效与高速剪辑的节奏感一览无余。",
      "### 强烈的视觉风格",
      "预告延续了动画版冷静而暴烈的镜头语言，配乐在安静与爆裂之间快速切换，强化了故事的张力。",
      "### 定档与上映范围",
      "官方同步确认了上映档期与海外发行计划，并表示将在上映前推出多支角色预告，逐步公开更多细节。",
    ],
    tags: ["链锯人", "剧场版", "预告"],
    views: 17480,
  },
  {
    id: "news-7",
    title: "《孤独摇滚！》确定制作剧场版总集篇，公开特报影像",
    category: "剧场版",
    publishedAt: "2026-10-06",
    dateLabel: "2026-10-06",
    summary:
      "以「结束乐队」的舞台为核心的总集篇剧场版正式立项，特报影像重现了多首人气曲目的演出场面。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20stylized%20illustration%20of%20a%20small%20live%20music%20stage%20with%20colorful%20stage%20lights%20and%20a%20guitar%20in%20the%20foreground%2C%20energetic%20youthful%20anime%20aesthetic%2C%20warm%20contrast%2C%20no%20text&width=800&height=500&seq=news-cover-07&orientation=landscape",
    content: [
      "《孤独摇滚！》官方宣布将制作剧场版总集篇，并公开特报影像。影像以「结束乐队」的现场演出为核心，重现了多首人气曲目的高光时刻。",
      "### 音乐与成长的共鸣",
      "作品以社恐少女加入乐队为起点，描绘了她在音乐与人际关系中的成长，许多观众从中找到了共鸣。",
      "### 上映信息",
      "总集篇将以更完整的演出剪辑与音效升级呈现，官方表示后续还会推出全新的宣传物料与联动活动。",
    ],
    tags: ["孤独摇滚", "剧场版", "音乐"],
    views: 8960,
  },
  {
    id: "news-8",
    title: "《药师少女的独语》第二季播出时间确定，追加声优阵容",
    category: "TV动画",
    publishedAt: "2026-10-05",
    dateLabel: "2026-10-05",
    summary:
      "后宫谜题将继续展开，官方公布第二季播出档期并追加多位声优，角色关系图同步更新。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20stylized%20illustration%20of%20a%20traditional%20chinese%20palace%20courtyard%20with%20red%20pillars%20and%20blossoming%20trees%2C%20refined%20historical%20anime%20aesthetic%2C%20soft%20daylight%2C%20no%20text&width=800&height=500&seq=news-cover-08&orientation=landscape",
    content: [
      "《药师少女的独语》第二季正式确定播出时间，官方同时公开了追加声优阵容与更新后的角色关系图。",
      "### 谜题与职场并行的叙事",
      "作品将后宫谜题与「职场生存」巧妙结合，主角以药学知识破解难题的桥段，一直是最受欢迎的看点之一。",
      "### 制作与美术",
      "第二季在服装与建筑美术上继续考据细节，色彩风格偏向沉稳典雅，营造出独特的时代氛围。",
    ],
    tags: ["药师少女的独语", "第二季", "声优"],
    views: 7640,
  },
  {
    id: "news-9",
    title: "知名漫画家新连载《星屑之诗》正式启动，首话同步公开",
    category: "漫画新闻",
    publishedAt: "2026-10-04",
    dateLabel: "2026-10-04",
    summary:
      "新作以「宇宙移民时代的诗歌」为主题，首话以细腻的线稿与浪漫的叙事获得读者好评。",
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20stylized%20illustration%20of%20a%20lone%20figure%20gazing%20at%20a%20vast%20starry%20galaxy%20from%20a%20futuristic%20observation%20deck%2C%20deep%20indigo%20and%20warm%20gold%20accents%2C%20poetic%20anime%20style%2C%20no%20text&width=800&height=500&seq=news-cover-09&orientation=landscape",
    content: [
      "知名漫画家带来的全新连载《星屑之诗》正式启动，首话同步在线上平台公开，迅速获得读者好评。",
      "### 以诗歌串联的宇宙叙事",
      "新作以宇宙移民时代为背景，用诗歌作为线索串联起不同角色的故事，叙事节奏舒缓而浪漫。",
      "### 画风与演出",
      "作者延续了标志性的细腻线稿，并在分镜中大量使用留白，营造出辽阔而安静的氛围。",
    ],
    tags: ["新连载", "星屑之诗", "漫画"],
    views: 6320,
  },
  {
    id: "news-10",
    title: "《进击的巨人》十周年纪念展将于东京举办，公开主题视觉",
    category: "漫画新闻",
    publishedAt: "2026-10-03",
    dateLabel: "2026-10-03",
    summary:
      "纪念展将展出原画、设定资料与巨大场景模型，官方同步公开了以城墙与大海为主题的主视觉。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20stylized%20illustration%20of%20a%20massive%20ancient%20stone%20wall%20overlooking%20a%20vast%20sea%20at%20dusk%20with%20warm%20amber%20and%20deep%20blue%20sky%2C%20dramatic%20anime%20painterly%20style%2C%20no%20text&width=800&height=500&seq=news-cover-10&orientation=landscape",
    content: [
      "为纪念《进击的巨人》系列的重要里程碑，官方宣布将在东京举办十周年纪念展，并公开了以城墙与大海为主题的主视觉图。",
      "### 展览内容抢先看",
      "展览将展出大量原画、设定资料与场景模型，并设置沉浸式影像区域，还原作品中的多个经典场面。",
      "### 限定周边",
      "官方表示将推出展览限定周边与纪念册，部分商品采用抽签方式发售。门票信息将在后续陆续公布。",
    ],
    tags: ["进击的巨人", "纪念展", "东京"],
    views: 14100,
  },
  {
    id: "news-11",
    title: "《命运石之门》推出重制版计划，经典剧情迎来高清化",
    category: "TV动画",
    publishedAt: "2026-10-02",
    dateLabel: "2026-10-02",
    summary:
      "官方宣布经典科幻作品将推出高清重制版，原班制作团队参与修复，画面与音效全面升级。",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20stylized%20illustration%20of%20a%20cluttered%20lab%20with%20old%20monitors%20glowing%20green%20in%20a%20dark%20room%2C%20nostalgic%20sci%20fi%20anime%20aesthetic%2C%20moody%20lighting%2C%20no%20text&width=800&height=500&seq=news-cover-11&orientation=landscape",
    content: [
      "经典科幻作品《命运石之门》官方宣布推出高清重制版计划，将在保持原有故事的前提下，对画面与音效进行全面提升。",
      "### 经典剧情的再呈现",
      "作品以时间旅行为核心，凭借缜密的逻辑与深刻的人物塑造，成为许多观众心中的「必看神作」。",
      "### 修复与升级细节",
      "官方表示本次重制由原班制作团队参与监修，画面分辨率与色彩表现将大幅改善，重制版的上线时间将在后续公布。",
    ],
    tags: ["命运石之门", "重制版", "科幻"],
    views: 10240,
  },
  {
    id: "news-12",
    title: "国产动画《时光代理人》公布第三季制作决定，世界观全面扩展",
    category: "TV动画",
    publishedAt: "2026-10-01",
    dateLabel: "2026-10-01",
    summary:
      "国产口碑作品《时光代理人》宣布第三季制作决定，主创团队透露将探索更多时间线的可能性。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20stylized%20illustration%20of%20a%20rainy%20contemporary%20city%20with%20reflective%20streets%20and%20warm%20shop%20lights%2C%20cool%20teal%20and%20amber%20tones%2C%20cinematic%20animation%20style%2C%20no%20text&width=800&height=500&seq=news-cover-12&orientation=landscape",
    content: [
      "国产动画《时光代理人》正式宣布第三季制作决定。作为近年口碑突出的原创作品，其精巧的叙事结构一直为人称道。",
      "### 世界观的进一步扩展",
      "主创团队透露，第三季将探索更多时间线的可能性，并在视觉上尝试新的表现手法，为观众带来不同的体验。",
      "### 播出预期",
      "目前官方尚未公布具体档期，预计将在完成主要制作后陆续释出先导物料，值得持续关注。",
    ],
    tags: ["时光代理人", "国产动画", "第三季"],
    views: 8100,
  },
];